import { render, staticRenderFns } from "./trail-code-detail.vue?vue&type=template&id=ff149db2&scoped=true&"
import script from "./trail-code-detail.vue?vue&type=script&lang=js&"
export * from "./trail-code-detail.vue?vue&type=script&lang=js&"
import style0 from "./trail-code-detail.vue?vue&type=style&index=0&id=ff149db2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff149db2",
  null
  
)

export default component.exports